import { AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ChartOptions, ColorType, createChart, DeepPartial, IChartApi, ISeriesApi, LineStyle, SeriesType } from 'lightweight-charts';

const SERIES_OPTIONS: any = {
  Candlestick: {
    upColor: '#34F38C',
    downColor: '#FD2C52',
    borderVisible: false,
    wickUpColor: '#34F38C',
    wickDownColor: '#FD2C52'
  },
  Area: {
    lineColor: '#86EAE0',
    topColor: 'rgba(134, 234, 224, 0.5)',
    bottomColor: 'rgba(134, 234, 224, 0)'
  },
  Line: {
    color: '#34F38C',
    lineWidth: 2,
    crosshairMarkerVisible: false,
    priceLineVisible: false
  }
};

@Component({
  selector: 'app-lightweight-chart',
  templateUrl: './lightweight-chart.component.html',
  styleUrls: ['./lightweight-chart.component.scss']
})
export class LightweightChartComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('chart') chartElement: ElementRef;
  @Input() type: SeriesType = 'Candlestick';
  @Input() data: any[] = [];
  @Input() seriesOptions = {};
  @Input() chartOptions: DeepPartial<ChartOptions> = {
    layout: {
      background: { type: ColorType.Solid, color: 'transparent' },
      textColor: '#4F5D63'
    },
    grid: {
      horzLines: {
        style: LineStyle.Dashed,
        color: '#4F5D63'
      },
      vertLines: {
        visible: false
      }
    },
    timeScale: {
      timeVisible: true,
      secondsVisible: false
    }
  };

  private chart: IChartApi;
  private series: ISeriesApi<any>;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.series) {
      this.series.applyOptions({ ...SERIES_OPTIONS[this.type], ...this.seriesOptions });
      this.series.setData(this.data || []);
      this.chart.timeScale().fitContent();
    }
  }

  ngAfterViewInit() {
    this.chart = createChart(this.chartElement.nativeElement, this.chartOptions);
    const seriesOptions = { ...SERIES_OPTIONS[this.type], ...this.seriesOptions };
    if (this.type === 'Candlestick') {
      this.series = this.chart.addCandlestickSeries(seriesOptions);
    } else if (this.type === 'Area') {
      this.series = this.chart.addAreaSeries(seriesOptions);
    } else if (this.type === 'Line') {
      this.series = this.chart.addLineSeries(seriesOptions);
    }
    this.series.setData(this.data || []);
    this.chart.timeScale().fitContent();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.chart.resize(this.chartElement.nativeElement.clientWidth, this.chartElement.nativeElement.clientHeight);
  }
}
